export * from './Device';

export interface EventLog extends Record<string, unknown> {
  uuid: string;
  createdAt: string;
  updatedAt: string;
  managedDeviceUuid: string;
  eventCategory: string;
  severity: string;
  event: string;
  timestamp: string;
}
interface LinkedDeployment {
  uuid: string;
  name: string;
  deploymentMethod: string;
}
// tooof
export interface CliTemplate extends Record<string, unknown> {
  uuid: string;
  createdAt?: string;
  updatedAt?: string;
  name: string;
  status?: string;
  tags?: string[] | null;
  content: string[];
  isComplex?: boolean;
  keysConfiguration: KeysConfiguration[];
  linkedDeployments?: LinkedDeployment[];
  fileType: TemplateType;
  containerDesignator?: string;
  containerConfigurationFileName?: string;
}

export interface InternalProperties {
  identifier: InternalPropertiesIdentifier;
  reference?: string;
}

export enum TemplateType {
  ASCII = 'ASCII_CONFIG',
  CONTAINER = 'CONTAINER_CONFIGURATION'
}

export enum InternalPropertiesIdentifier {
  PKI_CERT = 'pki:certificate',
  PKI_CERT_AUTHORITIES = 'pki:certificate-authority',
  PKI_CERT_KEY = 'pki:certificate-key',
  DEVICE_CONTROL = 'inventory:managed-device'
}

export interface KeysConfiguration {
  key: string;
  valueType: string;
  isDisabled?: boolean;
  isDeleted?: boolean;
  deletedAt?: number;
  isValid?: boolean;
  internalProperties?: InternalProperties;
}

export interface DryRunCliTemplate {
  deviceUuid: string;
  uuid: string;
  name: string;
  values: any;
}

export enum IpIntersection {
  EQUAL,
  NETWORK_INTERSECTION,
  NO_INTERSECTION
}
export interface QuickStartWanTypeConfigs {
  LTE: {
    pin?: string;
    apn?: string;
  };
  // DSL: {
  //    TODO
  // };
  // ...
}

export type QuickStartWan<
  T extends keyof QuickStartWanTypeConfigs = keyof QuickStartWanTypeConfigs
> = {
  type: T;
} & {
  [K in T]?: QuickStartWanTypeConfigs[K];
};

export interface QuickStartParams {
  apiVersion: number;
  asciiOnly?: boolean;
  spec: {
    wan?: QuickStartWan;
    lan?: {
      ip: string;
      netmask: number;
      dhcp?: {
        startip: string;
        endip: string;
        netmask?: number;
      };
    };
    system: {
      login: {
        username: string;
        password: string;
      };
    };
    services: {
      routerManagement: {
        deviceName: string;
        serialNumber: string;
        groupUuid?: string;
        location?: string;
        connect: boolean;
      };
      icsVpn?: { password: string; netmappingIp?: string };
    };
  };
}

export enum FirmwareAutoUpdate {
  ACTIVATE = 1,
  DEACTIVATE = 2
}
